import "./style.scss";
import Input from "@components/Input";
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import Chevron from "@assets/chevron.svg?react";
import Switch from "@components/Switch";
import {
  DETAILS_REFETCH_INVERVAL,
  getUserDetails,
  userDetailsUpdate,
} from "../../../api/consumer";
import NiceModal from "@ebay/nice-modal-react";
import SectionHeader from "../../../components/SectionHeader";

export default function UserData() {
  const queryClient = useQueryClient();

  const dataQuery = useQuery({
    queryKey: ["user-details"],
    queryFn: getUserDetails,
    refetchInterval: DETAILS_REFETCH_INVERVAL,
  });

  const [brands, setBrands] = useState([]);
  const redirectToken =
    queryClient.getQueryData(["consumer-redirect-token"]) ?? {};
  const redirectSoure =
    queryClient.getQueryData(["consumer-redirect-identify"]) ?? {};

  useEffect(() => {
    if (dataQuery?.data) {
      setBrands(dataQuery?.data?.consumer?.brands || []);
    }
  }, [dataQuery?.data]);

  const { register } = useForm({
    criteriaMode: "all",
    mode: "onTouched",
    reValidateMode: "onChange",
  });

  const handleDataRefresh = () => {
    setTimeout(() => {
      dataQuery?.refetch();
      queryClient.invalidateQueries(["homepage-coupons-list"]);
      queryClient.invalidateQueries(["homepage-activities-list"]);
      queryClient.invalidateQueries(["story-list"]);
      queryClient.invalidateQueries(["dashboard-slider"]);
    }, 500);
  };

  const handleToggleBrand = (brand) => {
    setBrands((prevBrands) => {
      if (prevBrands?.includes(brand)) {
        if (prevBrands.length === 1) {
          return prevBrands;
        }
        const updatedBrands = prevBrands.filter((b) => b !== brand);
        userDetailsUpdate(
          {
            consumer: {
              brands: updatedBrands,
            },
          },
          () => {
            handleDataRefresh();
          }
        );
        return updatedBrands;
      } else {
        const updatedBrands = [...prevBrands, brand];
        userDetailsUpdate(
          {
            consumer: {
              brands: updatedBrands,
            },
          },
          () => {
            handleDataRefresh();
          }
        );
        return updatedBrands;
      }
    });
  };

  const dateFormatter = (dateString) => {
    const formattedDate = new Intl.DateTimeFormat("pl-PL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

    return formattedDate.format(new Date(dateString));
  };

  const inputFields = [
    {
      name: "name",
      type: "text",
      placeholder: "Imię",
      defaultValue: dataQuery?.data?.consumer?.firstName,
      label: "Vorname",
      modal: "change-user-name",
    },
    {
      name: "surName",
      type: "text",
      placeholder: "Nazwisko",
      defaultValue: dataQuery?.data?.consumer?.lastName,
      label: "Nachname",
      modal: "change-user-last-name",
    },
    {
      name: "birthday",
      type: "birthday",
      placeholder: "Birthday",
      defaultValue: dateFormatter(dataQuery?.data?.consumer?.dob),
      label: "Dein Geburtstag",
      modal: "birthday",
    },
    {
      name: "email",
      type: "email",
      placeholder: "E-Mail",
      defaultValue: dataQuery?.data?.consumer?.emailAddress,
      label: "E-Mail",
      modal: "change-email",
    },
  ];

  const ecommConfig = {
    discoverglode: `${import.meta.env.VITE_DG_URL}/customer/account/`,
    vusede: `${import.meta.env.VITE_VUSE_URL}/account-landing`,
  };

  const handleEcommLinkClick = async (touchpoint) => {
    const url = ecommConfig[touchpoint];

    if (url) {
      window.location.href = url;
    }
  };

  return (
    <div className="user-data-wrapper">
      <div className="section-header-wrapper">
        <SectionHeader>
          <strong>Persönliche </strong>Daten
        </SectionHeader>
      </div>
      <div className="profile-section"></div>
      <form className="user-data-form" noValidate autoComplete="off">
        {inputFields.map((field, index) => (
          <div key={index} className="user-data-input-wrapper">
            <Input
              key={index}
              type={field.type}
              name={field.name}
              placeholder={field.placeholder}
              defaultValue={field.defaultValue}
              label={field.label}
              register={register}
              readOnly="readonly"
            />
          </div>
        ))}
        <a
          className="edit-account"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => handleEcommLinkClick(redirectSoure?.token?.touchpoint)}
        >
          <span className="line"></span>
          Deine Daten ändern
          <Chevron />
        </a>
        <p className="user-data-section">
          <span className="line"></span>
          <span className="strong">An welchen Marken</span>
          bist du interessiert?
        </p>
        <div className="switches">
          <Switch
            checked={brands?.includes("glo")}
            label={"glo™"}
            onChange={() => handleToggleBrand("glo")}
            register={() => {}}
            name="glo™"
          />
          <Switch
            checked={brands?.includes("vuse")}
            label={"Vuse"}
            onChange={() => handleToggleBrand("vuse")}
            register={() => {}}
            name="Vuse"
          />
        </div>
        <p className="switches-des">
          Mindestens eine Marke muss ausgewählt werden.
        </p>
        <p className="delete-account">
          <strong>Konto löschen</strong>
          <br />
          Wenn du dein Inspiration Club-Konto löschen möchtest, kannst du
          das&nbsp;
          <a
            onClick={() =>
              NiceModal.show("leave-program-modal", {
                redirectSoure: redirectSoure?.token?.touchpoint,
              })
            }
          >
            hier
          </a>
          &nbsp;tun.
        </p>
      </form>
    </div>
  );
}
